<template>
  <div>
    <button
      :aria-label="section.title"
      @click="setActiveItem('location')"
      @keyup.esc="closeFlyout"
    >
      <v-lazy-image
        :src="section.icon.source"
        :alt="section.icon.alt"
        width="24"
        height="24"
        class="icon"
      />
    </button>

    <pre-header-flyout
      v-if="preHeaderOpenItems.location"
      class="lang"
      @closeFlyout="closeFlyout"
    >
      <location-form />
    </pre-header-flyout>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import VLazyImage from 'v-lazy-image'

  const PreHeaderFlyout = () =>
    import(
      /* webpackChunkName: "pre-header-flyout" */ 'components/Header/White/PreHeader/PreHeaderFlyout'
    )

  const LocationForm = () =>
    import(/* webpackChunkName: "location-form" */ 'components/Header/White/LocationForm')

  export default {
    components: {
      VLazyImage,
      PreHeaderFlyout,
      LocationForm
    },
    props: {
      section: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapState('header', ['preHeaderOpenItems'])
    },
    methods: {
      setActiveItem(key) {
        if (this.preHeaderOpenItems[key]) {
          this.closeFlyout()
          return
        }

        this.$store.dispatch('header/openPreHeaderItem', key)
        this.$emit('show-backdrop')
      },
      closeFlyout() {
        this.$emit('close-backdrop')
      }
    }
  }
</script>

<style
  lang="scss"
  rel="stylesheet/scss"
  scoped
>
  @import '~assets/styles/common.scss';

  button {
    padding: 0;
    width: 40px;
    height: 40px;
    position: relative;
  }

  ::v-deep .pre-header-flyout {
    @include bp-mf-tablet {
      top: 40px !important;
      left: auto !important;
      right: -56px !important;
    }

    @include bp-mf-desktop {
      top: 40px !important;
      left: calc(50% - 70px) !important;
      right: auto !important;
    }
  }
</style>
